export function soilSpeechText(analysis, name) {
  const h = analysis?.soil_health || {};
  const crops = (analysis?.crops || []).slice(0, 4);
  const ferts = (analysis?.fertilizers || []).slice(0, 3);
  const tips = (analysis?.tips || []).slice(0, 3);
  const parts = [
    name ? `Soil report for ${name}.` : "Your soil report.",
    h.score != null ? `Soil health score ${Math.round(h.score)} out of 100, ${h.status || ""}.` : "",
    h.summary || "",
    crops.length ? `Best crops to plant: ${crops.map((c) => `${c.name}, ${Math.round(c.match || 0)} percent match`).join("; ")}.` : "",
    crops[0]?.calendar?.note ? `${crops[0].name}: ${crops[0].calendar.note}` : "",
    ferts.length ? `Recommended fertilizers: ${ferts.map((f) => `${f.name}${f.dosage ? `, ${f.dosage}` : ""}`).join("; ")}.` : "",
    tips.length ? `Tips: ${tips.map((t) => (typeof t === "string" ? t : t.text || t.tip || "")).join(" ")}` : "",
  ];
  return parts.filter(Boolean).join(" ");
}

export function pestSpeechText(report) {
  const r = report?.result || {};
  const steps = (r.treatments || []).slice(0, 4).map((t, i) => `Step ${i + 1}: ${t.step}. ${t.detail || ""}`);
  const products = (r.products || []).slice(0, 2).map((p) => `${p.name}${p.dosage ? `, ${p.dosage}` : ""}`);
  return [
    `Diagnosis: ${r.problem || "unknown problem"}${report?.crop ? ` on ${report.crop}` : ""}. ${r.severity || ""} severity.`,
    r.urgency_note || "",
    r.cause || "",
    steps.length ? `What to do. ${steps.join(" ")}` : "",
    products.length ? `Products: ${products.join("; ")}.` : "",
    (r.prevention || []).length ? `To prevent it next season: ${r.prevention.slice(0, 2).join(" ")}` : "",
  ].filter(Boolean).join(" ");
}

export function riskSpeechText(risk, fieldName) {
  const warns = (risk?.warnings || []).slice(0, 4).map((w) => `${w.problem}, ${w.risk} risk. ${w.action || ""} ${w.when || ""}`);
  return [
    `Pest and disease risk this week for ${fieldName}: ${risk?.overall_risk || "unknown"}.`,
    risk?.summary || "",
    warns.length ? `Watch out for: ${warns.join(". ")}` : "",
    (risk?.safe_windows || []).length ? `Good windows: ${risk.safe_windows.slice(0, 2).join(" ")}` : "",
  ].filter(Boolean).join(" ");
}
